export const Lang = {
    EN: 'en',
    DE: 'de',
    FR: 'fr',
    IT: 'it',
    ES: 'es',
} as const;
